import Model from './model.js'
import Deal from '~/models/deal.js'
import Event from '~/models/event.js'
import Communication from '~/models/communication.js'

export default class Contact extends Model {
	static _routeKey = 'contact'
	static _attributes = {
		origin_id: null,
		first_name: '',
		last_name: '',
		email: '',
		phone_number: '',
		address_line_1: '',
		address_line_2: '',
		town: '',
		postcode: '',
		lead_source_id: null,
		status: function (model) {
			if (model && model.archived_at != null) {
				return 'Archived'
			}

			return 'Active'
		},
	}

	_logIcon() {
		return 'IconUserDraftCircle'
	}

	static valuesFromLead(lead, vue) {
		let ai = lead?.call?.ai?.body != null ? lead?.call?.ai?.body : null

		return {
			first_name: String(lead.first_name || ai?.first_name || ''),
			last_name: String(lead.last_name || ai?.last_name || ''),
			origin: 100,
			origin_id: lead.id,
			email: String(lead.email || ai?.email || '').toLowerCase(),
			phone_number: String(lead.phone_number != null ? vue.$help.e164ToNumber(lead.phone_number, false) : '').replace('(', '').replace(')', ''),
			postcode: String(lead.postcode || ai?.postcode || '').toUpperCase(),
			address_line_1: ai?.address_line_1,
			address_line_2: ai?.address_line_2,
			town: ai?.town,
			lead_source_id: null,
		}
	}

	tailIgnore = ['company_id', 'origin_id', 'origin_type']

	tail = {
		town: () => ['City/town', this.town],
		postcode: () => ['Post code', this.postcode?.toUpperCase()],
		phone_number: () => ['Phone number', this.$help.e164ToNumber(this.phone_number)],
		archived_at: () => {
			return this.archived_at == null ? ['Status', 'Active', ''] : ['Status', 'Archived', '']
			// ? ['Active at', this.vue.$help.formatDateTime(this.$log.created_at, { date: true, time: true })]
			// : ['Archived at', this.vue.$help.formatDateTime(this.archived_at, { date: true, time: true })]
		},
		createdDescription: () => this.fullName() + ' was created',
		updatedDescription: {
			archived_at: () => 'This contact ' + (this.archived_at == null ? 'is now active' : 'was archived'),
		},
	}

	_constructor() {
		if (this.communications != null) {
			this.communications = Communication.fill(this.communications, {
				removed: false,
				$help: this.$help,
			})
		}

		if (this.deals != null) {
			this.deals = Deal.fill(this.deals, { $help: this.$help, vue: this.vue })
		}

		if (this.current_deal != null) {
			this.current_deal = new Deal(this.current_deal, { $help: this.$help, vue: this.vue })
		}

		if (this.current_appointment != null) {
			this.current_appointment = new Event(this.current_appointment, {
				vue: this.vue,
			})
		}

		if (this.current_task != null) {
			this.current_task = new Event(this.current_task, {
				vue: this.vue,
			})
		}
	}

	getPrimaryNumber() {
		if (this.communications == undefined) {
			return null
		}

		return this.communications.find((com) => {
			// console.log(parseInt(com.id), parseInt(this.primary_phone))
			return parseInt(com.id) == parseInt(this.primary_phone)
		})
	}

	getPrimaryEmail() {
		if (this.communications == undefined) {
			return null
		}

		return this.communications.find((com) => {
			return parseInt(com.id) == parseInt(this.primary_email)
		})
	}

	getBestCommunication() {
		if (this.getPrimaryNumber() != null) {
			return this.getPrimaryNumber()
		}

		return this.getPrimaryEmail()
	}

	fullName() {
		if (this.first_name == null) {
			return null
		}

		let name = this.first_name

		if (this.last_name) {
			name += ' ' + this.last_name
		}

		return name
	}

	icon() {
		switch (true) {
			case this.origin_id != null && this?.origin?.subscription?.product_id == 1:
				if (this.archived_at != null) {
					return 'IconZapoAdsLogoGrey'
				}
				return 'IconZapoAdsLogo'
			default:
				return 'IconZapoCrmLogo'
			// case this.origin_id == null:
			// 	return 'IconManualProspect'
		}
	}

	initals() {
		return (this.first_name != '' ? this.first_name[0] : '') + (this.last_name != '' ? this.last_name[0] : '')
	}

	hasAddress() {
		return (
			(this.address_line_1 != '' && this.address_line_1 != null) ||
			(this.address_line_2 != '' && this.address_line_2 != null) ||
			(this.town != '' && this.town != null) ||
			(this.postcode != '' && this.postcode != null)
		)
	}

	postcodeFormatted() {
		if (this.postcode == '' || this.postcode == null) {
			return ''
		}

		return toNormalised(this.postcode)
	}

	addressOverview(options, newLine = false) {
		let items = []

		if ((options.addr || options.addr == undefined) && this.address_line_1 != '' && this.address_line_1 != null) {
			items.push(this.address_line_1)
		}

		if ((options.addr2 || options.addr2 == undefined) && this.address_line_2 != '' && this.address_line_2 != null) {
			items.push(this.address_line_2)
		}

		if ((options.town || options.town == undefined) && this.town != '' && this.town != null) {
			items.push(this.town)
		}
		if ((options.post || options.post == undefined) && this.postcode != '' && this.postcode != null) {
			items.push(this.postcode)
		}

		if (items.length == 0) {
			return ''
		}

		if (newLine) {
			return items[0] + '<br />' + items.filter((a, b) => b != 0).join(', ')
		}

		return items.join(', ')
	}

	view() {
		return '/prospects/' + this.id
	}

	getColor() {
		const index = parseInt(this.id)
		const gridSize = 4
		const calculation = Math.floor(index / gridSize)
		const targetIndex = index - gridSize * calculation
		return this.vue.$help.randomColor('bg', targetIndex)
	}
}
